<template>
  <div class="chat-history-s">
    <div class="chat-history-box">
      <div class="history-filter">
        <div class="filter-history">
          <div class="filter-box">
            <div class="filter-title">高级筛选</div>
            <img class="filter-svg" src="@/assets/svg/filter.svg" />
          </div>

          <div class="filter-time">时间范围</div>
          <el-select v-model="timeRange" placeholder="请选择时间范围" class="filter-input">
            <el-option v-for="item in timeRangeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>

          <div class="filter-time">客户信息</div>
          <el-input v-model="id" placeholder="请输入客户 ID" class="filter-input" />
          <el-input v-model="nickName" placeholder="请输入客户名称" class="filter-input" />
          <el-input v-model="remark" type="textarea" :rows="5" class="filter-input" placeholder="请输入备注" />

          <div class="filter-actions">
            <el-button type="primary" @click="handleSearch" style="width: 100%">查询</el-button>
            <el-button @click="handleReset" style="width: 100%; margin: 10px 0 0 0">重置筛选</el-button>
          </div>
        </div>
      </div>

      <div class="history-box">
        <div class="history-box-title">
          <div class="history-title">
            <div class="history-lable">会话历史</div>
            <div class="history-count">共 {{ total }} 条</div>
          </div>

          <div class="calendar-box">
            <el-date-picker
              v-model="dateRange"
              @change="handleSearch"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              class="calendar-date-picker"
              :picker-options="pickerOptions"
            />

            <div class="history-export" @click="showHistory">
              <i class="el-icon-time iconTime"></i>
              <div class="export-text">历史记录</div>
            </div>
          </div>
        </div>

        <div class="history-table-wrap">
          <el-table :data="sessionList" class="chat-history-table" :header-cell-style="headerCellStyle" :cell-style="cellStyle">
            <el-table-column label="客户名称">
              <template slot-scope="{ row }">
                <div class="customer-cell">
                  <div class="customer-avatar" :style="{ background: row.headImage, color: row.headImage }">
                    {{ row.headImage }}
                  </div>
                  <span class="customer-name">{{ row.nickName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="客户 ID">
              <template slot-scope="{ row }">
                <div class="customer-id">ID: {{ row.id }}</div>
              </template>
            </el-table-column>
            <el-table-column label="备注">
              <template slot-scope="{ row }">
                <div class="customer-id">{{ row.remarkNickName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="会话时间">
              <template slot-scope="{ row }">
                <span class="session-time">{{ row.createdTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="响应时长">
              <template slot-scope="{ row }">
                <span class="duration-tag" :class="{ danger: isResponseTimeout(row.responseTime) }">
                  {{ row.responseTime }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="{ row }">
                <i class="el-icon-download iconDownload" @click="openExportDialog(row.id)" />
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-box">
            <div class="page-total">{{ pageTotalText }}</div>
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              :total="total"
              :pager-count="5"
              @current-change="handlePageChange"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog :visible.sync="exportList" width="30%" :show-close="false">
      <div class="export-title">导出申请</div>
      <div class="export-txt">详细说明</div>
      <el-input type="textarea" :rows="5" placeholder="请输入请求说明" v-model="textarea" />

      <div class="illustrateBox">
        <div class="illustrate-text">向管理发送导出申请</div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closureDialog">取 消</el-button>
          <el-button type="primary" @click="ExportConfirm">确 定</el-button>
        </span>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="outerVisible" :show-close="false" width="90%" margin-top="20px !important">
      <div class="history-close">
        <div class="close-box">
          <img class="close-icon" src="@/assets/image/close.png" />
          <div class="close-title">历史记录</div>
        </div>
        <i class="el-icon-close" v-if="outerVisible" @click="closeHistory" style="cursor: pointer; font-size: 25px" />
      </div>

      <div class="history-search">
        <div class="work-order">
          <div
            v-for="item in workOrderTypes"
            :key="item.value"
            class="work-order-title"
            :class="{ workTitle: activeWorkOrder === item.value }"
            @click="setActiveWorkOrder(item.value)"
          >
            {{ item.label }}
          </div>
        </div>

        <div class="history-search-box">
          <el-date-picker
            v-model="dialogDateRange"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            class="calendar-date-picker"
            :picker-options="pickerOptions"
          />
          <el-input class="search-input" prefix-icon="el-icon-search" v-model="searchInput" placeholder="搜索工单编号" />
        </div>
      </div>

      <el-table :data="pagedData">
        <el-table-column prop="name" label="申请人" />
        <el-table-column prop="serialNumber" label="工单编号" />
        <el-table-column prop="text" label="请求内容" />
        <el-table-column prop="time" label="提交时间" />

        <el-table-column prop="btn" label="当前状态">
          <template slot-scope="scope">
            <div :class="getStatusClass(scope.row.btn)" class="status-tag">
              {{ scope.row.btn }}
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="operate" label="操作">
          <template slot-scope="scope">
            <div class="scopeOperate" @click="openInnerDialog(scope.row)">
              {{ scope.row.operate }}
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="historyPageNum"
          :page-size="historyPageSize"
          :total="filteredData.length"
          @current-change="historyPageNum = $event"
        />
      </div>

      <el-dialog :show-close="false" :visible.sync="innerVisible" append-to-body>
        <div class="details-box">
          <div class="details-content">
            <div class="details-img-box">
              <img class="details-img" src="@/assets/image/details.png" />
            </div>
            <div class="details-box-title">
              <div class="details-title">工单详情</div>
              <div class="details-text">查看并处理当前的导出请求</div>
            </div>
          </div>
          <i class="el-icon-close" v-if="innerVisible" @click="details" style="cursor: pointer; font-size: 25px" />
        </div>
        <div style="padding: 0 32px; box-sizing: border-box">
          <div class="apply-box">
            <div class="apply-content">
              <img class="apply-img" :src="currentWorkOrder?.customerAvatar" />
              <div class="apply-people">
                <div class="people-text">申请人</div>
                <div class="people-name">{{ currentWorkOrder?.customerNickName }}</div>
              </div>
            </div>
            <div>
              <div class="serial-num">工单编号</div>
              <div class="serial-number">{{ currentWorkOrder?.customerId }}</div>
            </div>
          </div>
          <div class="surface-box">
            <i class="el-icon-warning-outline surface-iaon" />
            <div>
              <div class="surface-title">请求内容:</div>
              <div class="surface-text">{{ currentWorkOrder?.description }}</div>
            </div>
          </div>
          <div class="illustrate-box">
            <div class="illustrate-title">详细说明</div>
            <div class="illustrate-text">
              {{ currentWorkOrder?.requestContent }}
            </div>
          </div>
          <div class="status-display-box">
            <div class="status-dot" :class="getStatusDotClass(processedWorkOrder?.status)"></div>
            <div class="illustrate-state" :class="getStatusTextClass(processedWorkOrder?.status)">
              {{ processedWorkOrder?.status }}
            </div>
          </div>
        </div>
        <div class="apply-btn-box">
          <div class="apply-btn-text" :class="{ 'btn-disabled': currentWorkOrder?.status !== 2 }" @click="handleExportClick">导出</div>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import Api from "../api/index.js";

const apiInstance = new Api();

const HEADER_STYLE = {
  height: "54px",
  background: "#F9FAFB",
  color: "#9CA3AF",
  fontSize: "12px",
  fontWeight: 400,
  borderBottom: "1px solid #EEF0F3"
};

const CELL_STYLE = {
  height: "78px",
  borderBottom: "1px solid #F3F4F6"
};

const TIME_RANGE_OPTIONS = [
  { label: "最近 24 小时", value: "24h" },
  { label: "最近 72 小时", value: "72h" },
  { label: "最近一周", value: "7d" },
  { label: "最近一月", value: "30d" },
  { label: "最近一年", value: "1y" }
];

const WORK_ORDER_TYPES = [
  { label: "全部工单", value: "all" },
  { label: "待审批", value: "pending" },
  { label: "已通过", value: "approved" },
  { label: "已拒绝", value: "rejected" }
];

const STATUS_LABEL_MAP = {
  pending: "待审批",
  approved: "已通过",
  rejected: "已拒绝"
};

const STATUS_CLASS_MAP = {
  待审批: "status-pending",
  已通过: "status-approved",
  已拒绝: "status-rejected"
};

const STATUS_TEXT_MAP = {
  1: "待审批",
  2: "已通过",
  3: "已拒绝"
};

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

function getDefaultDateRange() {
  const now = new Date();
  const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  return [formatDate(startOfMonth), formatDate(now)];
}

function getRangeByType(type) {
  const now = new Date();
  const start = new Date(now);
  const handlers = {
    "24h": () => start.setHours(now.getHours() - 24),
    "72h": () => start.setHours(now.getHours() - 72),
    "7d": () => start.setDate(now.getDate() - 7),
    "30d": () => start.setDate(now.getDate() - 30),
    "1y": () => start.setFullYear(now.getFullYear() - 1)
  };
  if (handlers[type]) handlers[type]();
  return [formatDate(start), formatDate(now)];
}

function getNextDate(dateStr) {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + 1);
  return formatDate(date);
}

export default {
  name: "chatHistory",

  data() {
    return {
      timeRangeOptions: TIME_RANGE_OPTIONS,
      workOrderTypes: WORK_ORDER_TYPES,
      timeRange: "24h",
      id: "",
      nickName: "",
      remark: "",
      dateRange: getDefaultDateRange(),
      pageNum: 1,
      pageSize: 10,
      total: 0,
      sessionList: [],
      exportList: false,
      exportVisitorId: null,
      textarea: "",
      requestType: 2,
      outerVisible: false,
      innerVisible: false,
      currentWorkOrder: null,
      activeWorkOrder: "all",
      searchInput: "",
      dialogDateRange: getDefaultDateRange(),
      allTableData: [],
      historyPageNum: 1,
      historyPageSize: 10,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },

  created() {
    this.visitorList();
  },

  computed: {
    pageTotalText() {
      if (!this.total) return "共 0 条记录";
      const start = (this.pageNum - 1) * this.pageSize + 1;
      const end = Math.min(this.pageNum * this.pageSize, this.total);
      return `显示第 ${start} 到 ${end} 条，共 ${this.total.toLocaleString()} 条记录`;
    },

    filteredData() {
      let data = this.allTableData;
      if (this.activeWorkOrder !== "all") {
        const statusText = STATUS_LABEL_MAP[this.activeWorkOrder];
        data = data.filter((item) => item.btn === statusText);
      }
      if (this.searchInput) {
        data = data.filter((item) => String(item.serialNumber || "").includes(this.searchInput));
      }
      return data;
    },

    pagedData() {
      const start = (this.historyPageNum - 1) * this.historyPageSize;
      return this.filteredData.slice(start, start + this.historyPageSize);
    },

    processedWorkOrder() {
      if (!this.currentWorkOrder) return null;
      return {
        ...this.currentWorkOrder,
        status: this.mapStatus(this.currentWorkOrder.status)
      };
    }
  },

  watch: {
    timeRange(value) {
      this.dateRange = getRangeByType(value);
      this.handleSearch();
    },

    outerVisible(value) {
      if (value) this.historyPageNum = 1;
    },

    activeWorkOrder: "resetHistoryPage",
    searchInput: "resetHistoryPage",
    dialogDateRange() {
      this.resetHistoryPage();
      if (this.outerVisible) this.showHistory();
    }
  },

  methods: {
    headerCellStyle() {
      return HEADER_STYLE;
    },

    cellStyle() {
      return CELL_STYLE;
    },

    resetHistoryPage() {
      this.historyPageNum = 1;
    },

    handleSearch() {
      this.pageNum = 1;
      this.visitorList();
    },

    handleReset() {
      Object.assign(this, {
        timeRange: "24h",
        id: "",
        nickName: "",
        remark: "",
        dateRange: getDefaultDateRange(),
        pageNum: 1
      });
      this.visitorList();
    },

    handlePageChange(page) {
      this.pageNum = page;
      this.visitorList();
    },

    buildVisitorListParams() {
      const params = {
        visitorId: this.id,
        nickName: this.nickName,
        remark: this.remark,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = getNextDate(this.dateRange[1]);
      }
      return params;
    },

    async visitorList() {
      try {
        const res = await apiInstance.visitorList(this.buildVisitorListParams());
        this.sessionList = res?.rows || [];
        this.total = res?.total || 0;
      } catch (error) {
        console.error("获取会话历史失败:", error);
        this.$message.error("数据加载失败");
        this.sessionList = [];
        this.total = 0;
      }
    },

    openExportDialog(visitorId) {
      this.exportVisitorId = visitorId;
      this.exportList = true;
    },

    closureDialog() {
      this.exportList = false;
      this.textarea = "";
      this.exportVisitorId = null;
    },

    async ExportConfirm() {
      const description = (this.textarea || "").trim();
      if (!description) {
        this.$message.warning("请输入请求说明");
        return;
      }
      if (!this.exportVisitorId) {
        this.$message.error("客户ID不存在");
        return;
      }
      try {
        await apiInstance.apply({
          visitorId: [this.exportVisitorId],
          requestType: this.requestType,
          description
        });
        this.$message.success("申请已提交");
        this.closureDialog();
      } catch (error) {
        console.error("导出申请失败:", error);
        this.$message.error("申请提交失败");
      }
    },

    mapStatus(status) {
      return STATUS_TEXT_MAP[status] || "待审批";
    },

    mapWorkOrder(item) {
      return {
        id: item.id,
        name: item.customerNickName,
        serialNumber: item.ticketNo,
        text: item.requestContent,
        time: item.createTime,
        description: item.description,
        status: item.status,
        btn: this.mapStatus(item.status),
        operate: "查看详情"
      };
    },

    async showHistory() {
      this.outerVisible = true;
      this.historyPageNum = 1;
      try {
        const params = {
          requestType: this.requestType
        };
        if (this.dialogDateRange && this.dialogDateRange.length === 2) {
          params.startTime = this.dialogDateRange[0];
          params.endTime = getNextDate(this.dialogDateRange[1]);
        }
        const res = await apiInstance.history(params);
        this.allTableData = (res?.rows || []).map(this.mapWorkOrder);
      } catch (error) {
        console.error("获取工单列表失败:", error);
        this.$message.error("工单数据加载失败");
        this.allTableData = [];
      }
    },

    closeHistory() {
      this.outerVisible = false;
    },

    setActiveWorkOrder(value) {
      this.activeWorkOrder = value;
    },

    async openInnerDialog(row) {
      if (!row || !row.id) {
        this.$message.error("工单ID不存在");
        return;
      }
      this.innerVisible = true;
      try {
        const rows = await apiInstance.info(row.id);
        this.currentWorkOrder = rows?.data || rows || null;
      } catch (error) {
        console.error("获取工单详情失败:", error);
        this.$message.error("工单详情加载失败");
        this.currentWorkOrder = null;
      }
    },

    details() {
      this.innerVisible = false;
      this.currentWorkOrder = null;
    },

    getStatusClass(status) {
      return STATUS_CLASS_MAP[status] || "";
    },

    // 导出工单
    async handleExportClick() {
      if (this.currentWorkOrder?.status !== 2) return;
      const ticketId = this.currentWorkOrder.id;
      if (!ticketId) {
        this.$message.error("工单ID不存在");
        return;
      }
      try {
        const res = await apiInstance.export(ticketId);
        const blob = res instanceof Blob ? res : new Blob([res]);
        this.downloadExcel(blob, ticketId);
      } catch (error) {
        console.error("导出失败 error = ", error);
        this.$message.error("导出失败");
      }
    },

    downloadExcel(blob, ticketId) {
      if (!blob) {
        this.$message.error("导出文件为空");
        return;
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `工单历史记录_${ticketId}.xlsx`;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    },

    getStatusDotClass(status) {
      if (!status) return "";
      // 中文 "待审批", "已通过", "已拒绝"
      if (status === "待审批") return "dot-pending";
      if (status === "已通过") return "dot-approved";
      if (status === "已拒绝") return "dot-rejected";
      return "";
    },

    // 获取状态文字的颜色类
    getStatusTextClass(status) {
      if (!status) return "";
      if (status === "待审批") return "text-pending";
      if (status === "已通过") return "text-approved";
      if (status === "已拒绝") return "text-rejected";
      return "";
    },

    isResponseTimeout(responseTime) {
      if (responseTime === null || responseTime === undefined || responseTime === "") {
        return false;
      }
      const time = Number(responseTime);
      if (Number.isNaN(time)) {
        return false;
      }
      // 假设超过 60 秒标红
      return time > 60;
    }

    // 如果后端返回的是毫秒，就这样：↓
    // isResponseTimeout(responseTime) {
    //   if (responseTime === null || responseTime === undefined || responseTime === '') {
    //     return false
    //   }

    //   const time = Number(responseTime)

    //   if (Number.isNaN(time)) {
    //     return false
    //   }

    //   // 超过 60 秒，也就是 60000 毫秒标红
    //   return time > 60000
    // }

    // 如果 responseTime 是 "12秒"、"120s" 这种字符串
    // isResponseTimeout(responseTime) {
    //   if (!responseTime) return false

    //   const time = parseFloat(String(responseTime).replace(/[^\d.]/g, ''))

    //   if (Number.isNaN(time)) return false

    //   return time > 60
    // }
  }
};
</script>

<style scoped lang="scss">
.chat-history-s {
  height: calc(100vh - 65px);
  width: 100%;
  overflow: auto;
  background: #f2f3f5;

  .chat-history-box {
    display: flex;
    padding: 20px;
    box-sizing: border-box;

    .history-filter {
      width: 25%;
      background: #fff;
      border-radius: 5px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .filter-history {
        padding: 20px;
        box-sizing: border-box;

        .filter-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 15px;
          box-sizing: border-box;
          border-bottom: 1px solid #f3f4f6;

          .filter-title {
            color: #111827;
            font-size: 18px;
            font-weight: 600;
          }

          .filter-svg {
            width: 18px;
            height: 18px;
          }
        }

        .filter-time {
          color: #909399;
          font-size: 12px;
          padding-top: 15px;
          margin-bottom: 5px;
          box-sizing: border-box;
          text-align: left;
        }

        .filter-input {
          width: 100%;
          margin-top: 5px;
        }

        .filter-actions {
          margin-top: 20px;
        }
      }
    }

    .iconTime {
      font-size: 20px;
      color: #9b9b9b;
    }

    .history-box {
      width: 73%;
      margin-left: 20px;
      border-radius: 8px;
      background-color: #fff;
      border: 1px solid #e5e7eb;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

      .history-box-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;

        .history-title {
          display: flex;
          align-items: center;
          padding-left: 20px;
          box-sizing: border-box;

          .history-lable {
            min-width: 96px;
            font-size: 24px;
            color: #111827;
            font-weight: 400;
          }

          .history-count {
            min-width: 70px;
            height: 20px;
            color: #4b5563;
            font-size: 12px;
            padding: 2px 8px;
            margin-left: 20px;
            border-radius: 2px;
            background: #f3f4f6;
            box-sizing: border-box;
            margin-right: 50px;
          }
        }

        .calendar-box {
          padding-right: 20px;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .calendar-date-picker {
            width: 260px;
            font-size: 14px;
            color: #0058bc;
            border-radius: 4px;
            border: 1px solid #e5e7eb;
            cursor: pointer;
          }

          .history-export {
            display: flex;
            align-items: center;
            padding: 8px 16px;
            border-radius: 4px;
            box-sizing: border-box;
            border: 1px solid #e5e7eb;
            margin-left: 10px;
            cursor: pointer;

            .export-text {
              width: 64px;
              color: #9b9b9b;
              margin-left: 10px;
            }
          }
        }
      }
    }
  }
}

.export-title {
  font-size: 14px;
  color: #374151;
  font-weight: bold;
  margin-bottom: 50px;
  text-align: left;
}

.export-txt {
  font-size: 12px;
  color: #374151;
  text-align: left;
  margin-bottom: 10px;
}

.illustrateBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;

  .illustrate-text {
    font-size: 14px;
    color: #000000;
  }
}

.illustrate-box {
  background: #e5eeff;
  padding: 25px;
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #c1c6d74d;
  margin-bottom: 30px;

  .illustrate-title {
    font-size: 16px;
    color: #717786;
    margin-bottom: 15px;
  }

  .illustrate-text {
    font-size: 16px;
    color: #0b1c30;
    margin-bottom: 15px;
  }
}

.illustrate-title {
  font-size: 16px;
  color: #717786;
  margin-bottom: 15px;
}

.history-table-wrap {
  width: 100%;
  background: #fff;
  border-radius: 0 0 6px 6px;
  overflow: hidden;

  .chat-history-table {
    width: 100%;

    ::v-deep .el-table__header-wrapper th {
      padding: 0;
    }

    ::v-deep .el-table__body-wrapper td {
      padding: 0;
    }

    ::v-deep .el-table::before {
      display: none;
    }
  }

  .customer-cell {
    display: flex;
    align-items: center;
  }

  .customer-avatar {
    width: 26px;
    height: 26px;
    border-radius: 10px;
    margin-right: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }

  .customer-name {
    font-size: 14px;
    color: #111827;
  }

  .customer-id {
    font-size: 12px;
    color: #6b7280;
    line-height: 18px;
  }

  .session-time {
    font-size: 13px;
    color: #4b5563;
  }

  .duration-tag {
    display: inline-block;
    padding: 2px 6px;
    line-height: 18px;
    border-radius: 2px;
    font-size: 12px;
    color: #16a34a;
    background: #ecfdf5;

    &.danger {
      color: #f97316;
      background: #fff7ed;
    }
  }

  .iconDownload {
    font-size: 22px;
    cursor: pointer;
    color: #2764e6;
  }

  .pagination-box {
    height: 54px;
    padding: 0 22px;
    background: #f9fafb;
    border-top: 1px solid #eef0f3;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .page-total {
      font-size: 12px;
      color: #6b7280;
    }

    ::v-deep .el-pagination.is-background .el-pager li {
      background: #fff;
      border: 1px solid #e5e7eb;
      color: #6b7280;
      min-width: 28px;
      height: 28px;
      line-height: 28px;
      font-weight: 400;
    }

    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
      background: #0058e6;
      border-color: #0058e6;
      color: #fff;
    }

    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination.is-background .btn-next {
      background: #fff;
      border: 1px solid #e5e7eb;
      min-width: 28px;
      height: 28px;
      line-height: 28px;
    }
  }
}

.history-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f1f5f9;
  padding: 20px 0;
  box-sizing: border-box;
  margin-bottom: 20px;

  .close-box {
    display: flex;
    align-items: center;

    .close-icon {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }

    .close-title {
      font-size: 30px;
      color: #0f172a;
      font-weight: 400;
    }
  }
}

.history-search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  .work-order {
    width: 435px;
    padding: 4px;
    box-sizing: border-box;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    border-radius: 4px;
    margin-right: 50px;

    .work-order-title {
      width: 110px;
      font-size: 14px;
      color: #64748b;
      padding: 8px 0;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s;

      &.workTitle {
        color: #0052d9;
        background-color: #ffffff;
        border-radius: 4px;
      }
    }
  }

  .history-search-box {
    display: flex;
    align-items: center;

    .search-input {
      width: 80%;
      margin-left: 10px;
      border-radius: 8px;
      border: 1px solid#E2E8F0;
    }
  }
}

.details-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 32px;
  box-sizing: border-box;
  margin-bottom: 30px;
  border-bottom: 1px solid #f1f5f9;

  .details-content {
    display: flex;
    align-items: center;

    .details-img-box {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #adc6ff;

      .details-img {
        width: 16px;
        height: 20px;
      }
    }

    .details-box-title {
      margin-left: 10px;

      .details-title {
        font-size: 16px;
        color: #0b1c30;
      }

      .details-text {
        font-size: 14px;
        color: #717786;
      }
    }
  }
}

.apply-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px;
  box-sizing: border-box;
  border: 1px solid #f1f5f9;
  border-radius: 8px;
  margin-bottom: 30px;

  .apply-content {
    display: flex;
    align-items: center;

    .apply-img {
      width: 48px;
      height: 48px;
      border-radius: 12px;
    }

    .apply-people {
      margin-left: 10px;

      .people-text {
        font-size: 14px;
        color: #717786;
      }

      .people-name {
        font-size: 18px;
        color: #0b1c30;
      }
    }
  }

  .serial-num {
    font-size: 14px;
    color: #717786;
    text-align: right;
    margin-bottom: 5px;
  }

  .serial-number {
    font-size: 16px;
    color: #0070eb;
    text-align: center;
    background: #d8e2ff4d;
    padding: 10px 20px;
    box-sizing: border-box;
    border-radius: 12px;
  }
}

.surface-box {
  display: flex;
  margin-bottom: 30px;

  .surface-iaon {
    font-size: 25px;
    color: #9e3d00;
    margin-right: 10px;
    margin-top: 3px;
  }

  .surface-title {
    font-size: 16px;
    color: #0b1c30;
  }

  .surface-text {
    font-size: 16px;
    color: #414755;
  }
}

.illustrate-state {
  font-size: 14px;
  color: #006f66;
  margin-left: 10px;
}

.apply-btn-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 25px 32px;
  box-sizing: border-box;

  .apply-btn-text {
    width: 125px;
    height: 40px;
    color: #ffffff;
    line-height: 40px;
    background: #0052d9;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;

    &.btn-disabled {
      background-color: #cbd5e1 !important;
      color: #94a3b8 !important;
      cursor: pointer !important;
    }
  }
}

.status-tag {
  width: 60px;
  height: 25px;
  line-height: 25px;
  font-size: 12px;
  border-radius: 12px;
  text-align: center;
  display: inline-block;
}

.scopeOperate {
  color: #0052d9;
  cursor: pointer;
  font-size: 14px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 20px 30px 10px 30px;
  box-sizing: border-box;
}

.status-pending {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.status-approved {
  background-color: #86f2e4;
  color: #006f66;
}

.status-rejected {
  background-color: #ffdad6;
  color: #93000a;
}

.status-display-box {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 10px;
}

.dot-pending {
  background-color: #1d4ed8;
}

.dot-approved {
  background-color: #006f66;
}

.dot-rejected {
  background-color: #93000a;
}

.text-pending {
  color: #1d4ed8;
}

.text-approved {
  color: #006f66;
}

.text-rejected {
  color: #93000a;
}

.illustrate-state {
  font-size: 14px;
}

::v-deep .el-dialog__header {
  padding: 0 !important;
}

::v-deep(.el-range-input),
::v-deep(.el-range-separator) {
  color: #0058bc;
}
</style>
